/**
 * `AssignmentType` mirrors `App\Enums\Assignment\AssignmentType` and `AssignmentStatus` mirrors
 * `App\Enums\LearningMaterial\LearningMaterialStatus` in `base-main-app`: the values are wire values
 * and must not be renamed independently. Kept local, not in lib-core-types.
 */
export { Grade } from '@brighterly/lib-core-types/kid/enums'

/**
 * The homework family — and the learning material a template creates for itself on `POST`: READING
 * authors a PASSAGE, MATH a MATH_PRACTICE. Fixed at creation (a type change is a 422). Since RND-196
 * it IS the document-schema discriminator: READING is a chapter book, MATH an exercise set
 * (`documentSchemaFor`).
 */
export enum AssignmentType {
  Reading = 'READING',
  Math = 'MATH',
}

/** The owned material's status, flattened onto the template. Gated client-side only: the API stores
 *  whatever status it is sent. */
export enum AssignmentStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Archived = 'ARCHIVED',
}

/** One exercise of a MATH template. Wire values of `exercises[].type`; see `math-practice-schema.ts`. */
export enum MathExerciseType {
  MultipleChoice = 'multiple_choice',
  Numeric = 'numeric',
  MatchPairs = 'match_pairs',
  Order = 'order',
  NumberLine = 'number_line',
  MultiStep = 'multi_step',
}
